export default __webpack_public_path__ + "static/media/hs_Legend.2012a2b6.svg";